<template>
	<div class="inner-content shadowed">
		<div class="inner-content-title" style="border-bottom: 1px solid #f0f0f0">
			Usuários do sistema
			<button class="add-new" @click="create">
				<i class="fa fa-plus"></i> ADICIONAR
			</button>
		</div>
		<Table 
			:loading="loading"
			:headers="headers" 
			:modifiers="modifiers"
			:ordering="['id']" 
			:list="list" 
			:page="0"
			:per_page="0" 
			:total="list.length" 
			v-slot="{item}">
				<button v-if="($api.user.is_admin) || (!$api.user.is_admin && !item.is_admin)" class="button-edit" @click="edit(item)" title="Editar usuário">
					<i class="fa fa-fw fa-edit"></i>
				</button>
				<button v-if="(!item.is_admin) && ($api.user.id != item.id)" class="button-edit" @click="editPermissions(item)" title="Editar permissões">
					<i class="fa fa-fw fa-check"></i>
				</button>
				<button v-if="($api.user.is_admin) || (!item.is_admin)" class="button-edit" @click="editTours(item)" title="Editar tours">
					<i class="fa fa-fw fa-question-circle"></i>
				</button>
				<button v-if="($api.user.is_admin) || (item.is_admin != 1)" class="button-remove" @click="remove(item)" title="Remover usuário">
					<i class="fa fa-fw fa-trash"></i>
				</button>
		</Table>

		<ConfigUsersForm v-if="show_config_users_form"
			:current="current"
			@close="close()" 
		/>
		
		<ConfigUsersPermissions v-if="show_config_users_permissions"
			:current="current"
			@close="close()"
		/>

		<ConfigUsersTours v-if="show_config_users_tours"
			:current="current"
			@close="close()"
		/>
	</div>
</template>

<script>
import Api from "@/lib/Api";

import Table from "@/components/Table";
import ConfigUsersForm from "./ConfigUsersForm";
import ConfigUsersPermissions from "./ConfigUsersPermissions";
import ConfigUsersTours from "./ConfigUsersTours";

export default {
	name: "ConfigUsers",

	components: {
		Table,
		ConfigUsersForm,
		ConfigUsersPermissions,
		ConfigUsersTours,
	},

	data: function() {
		return {
			loading: true,
			headers: {
				name: "Nome",
				email: "E-mail",
				is_admin: "Administrador",
				status: "Status"
			},
			modifiers: {
				status: function(d) {
					return d ? "Ativo" : "Inativo";
				},

				is_admin: function(d) {
					return d ? "Sim" : "Não";
				}
			},
			list: [],

			current: null,
			show_config_users_form: false,
			show_config_users_permissions: false,
			show_config_users_tours: false,
		}
	},


	mounted: function() {
		this.load();
	},


	methods: {
		load: async function() {
			this.loading = true;
			let res = await Api.post("user/get-users");
			this.loading = false;

			if (res.error) {
				this.$notification.error(res.data);
				return;
			}

			this.list = res.data;
		},

		create: function() {
			this.current = 'new';
			this.show_config_users_form = true;
		},

		edit: function(item) {
			this.current = item;
			this.show_config_users_form = true;
		},
		
		editPermissions: function(item) {
			this.current = item;
			this.show_config_users_permissions = true;
		},
		
		editTours: function(item) {
			this.current = item;
			this.show_config_users_tours = true;
		},

		remove: async function(user) {
			if (user.is_admin) {
				this.$notification.error("Você não pode excluir um usuário administrador.");
			}

			let confirm = await this.$alert.confirm("Tem certeza que deseja excluir o usuário?");
			
			if (!confirm) return;

			this.loading = true;
			let res = await Api.post("user/remove-user", {id: user.id});
			this.loading = false;

			if (res.error) {
				this.$notification.error(res.data);
			}

			this.load();
		},

		close: function() {
			this.show_config_users_form = false;
			this.show_config_users_permissions = false;
			this.show_config_users_tours = false;
			this.current = null;
		},
	}
}
</script>

<style scoped>
.add-new {
	float: right;
	margin-top: 10px;
	border: none;
	background: #d9d9d9;
	color: #000;
	font-weight: bold;
	font-size: 12px;
	padding: 10px 15px;
	margin-left: 15px;
}

.button-create {
	float: right;
	margin-top: 5px;
}

</style>